import { render, staticRenderFns } from "./demo-indirect-alcohol-promo-flow.vue?vue&type=template&id=2dcd3faa&scoped=true&"
import script from "./demo-indirect-alcohol-promo-flow.vue?vue&type=script&lang=js&"
export * from "./demo-indirect-alcohol-promo-flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd3faa",
  null
  
)

export default component.exports